import { type WorkshopShell } from '../../dashboards/workshopDetailUrlFor';
import type { useBookingsList } from '../useBookingsListState';

import { BookingListBody } from './BookingListBody';
import { BookingPager } from './BookingPager';

/** Count label (gated on loading so it never flashes "0 bookings") + the list
 *  body + the pager. Split out to keep the page component's render simple. */
export function BookingResults({
  s,
  isDesktop,
  isTablet,
  shell,
}: {
  s: ReturnType<typeof useBookingsList>;
  isDesktop: boolean;
  isTablet: boolean;
  shell: WorkshopShell;
}) {
  const ready = !s.loading && !s.error;
  const countLabel = `${s.totalCount} ${s.totalCount === 1 ? 'booking' : 'bookings'}`;
  return (
    <>
      {ready && <p className="mb-3 text-sm text-stone-500">{countLabel}</p>}
      <BookingListBody
        loading={s.loading}
        error={s.error}
        bookings={s.bookings}
        filtered={s.searchInput !== '' || s.status !== 'all'}
        isDesktop={isDesktop}
        isTablet={isTablet}
        sort={s.sort}
        dir={s.dir}
        onSort={s.toggleSort}
        shell={shell}
      />
      {ready && s.totalCount > 0 && <BookingPager s={s} />}
    </>
  );
}
